<template>
    <section
        id="section-services-id-link"
        class="section-services bg-black-700 full-width relative phone:h-screen tabletLandscape:h-screen flex flex-col">
        <!--Image Background-->
        <transition name="fade">
            <background-image
                :key="currentProductSlug"
                :src="currentSlideContentElement('src')"
                :srcset="currentSlideContentElement('imgSrcSet')" />
        </transition>

        <!-- Navigation for Slider -->
        <div
            class="product-controls flex flex-grow px-4 mt-8 z-40 justify-between tablet:absolute tablet:top-12 tabletLandscape:top-8 tabletLandscape:flex-col tabletLandscape:mr-10 desktop:left-12 hd:left-24">
            <product-controls
                v-for="(category, categoryIndex) in servicesCategories"
                :key="categoryIndex"
                class="mx-4 phone:w-1/2  tablet:w-1/2"
                :products="category.serviceItems"
                :category-label="category.categoryLabel"
                :category-slug="category.categoryId"
                :current-product-slug="currentProductSlug"
                :is-active-dropdown="currentCategorySlug === category.categoryId"
                :on-product-change="handleSlideChange"
            />
        </div>

        <!--Content Layout in a Container-->
        <div
            class="container flex phone:flex-col phone:justify-end flex-grow z-10 pt-8 tablet:pt-16 pb-16 tablet:items-end">
            <!--Layout Spacer -- Matches Aside Text Component sizing/spacing-->
            <div class="hidden tabletLandscape:flex w-1/4 max-w-xxs mr-10 desktop:mr-32"></div>

            <!--Content Block & CTA-->
            <div class="section-text-with-button flex flex-col items-start">
                <!--Content Text Component-->
                <content-text>
                    <template #title-text>
                        <h2 class="font-bold">
                            {{ currentSlideContentElement('title') }}
                        </h2>
                    </template>
                    <template #content-text>
                        <div
                            class="font-regular mb-6"
                            v-html="currentSlideContentElement('content')">
                        </div>
                        <div
                            class="font-regular mb-6"
                            v-html="currentSlideContentElement('pricing')">
                        </div>
                    </template>
                </content-text>

                <!-- CTA button -->
                <cta-button
                    :key="currentProductSlug"
                    :url="currentUrl('buttonRoute')"
                    :target="buttonTarget()"
                    :text="currentSlideContentElement('buttonText')"
                />
            </div>
        </div>
    </section>
</template>

<script>
import ContentText from '@web/components/ContentText';
import BackgroundImage from '@web/components/BackgroundImage';
import CtaButton from '@whisper/components/buttons/CtaButton';
import ProductControls from '@web/components/ProductGalleries/controls/ProductControls';
import get from 'lodash/get';

export default {
  components: {
    ProductControls,
    CtaButton,
    ContentText,
    BackgroundImage,
  },
  props: {
    servicesCategories: {
      type: Object,
      required: true,
    },
    sectionServicesSlides: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      currentCategorySlug: 'post-production',
      currentProductSlug: 'post-production-wedding-events',
    };
  },
  methods: {
    handleSlideChange(productSlug, categorySlug) {
      // update the new category and slide
      this.currentCategorySlug = categorySlug;
      this.currentProductSlug = productSlug;
    },
    buttonTarget() {
      return this.currentSlideContentElement('target');
    },
    currentUrl(content) {
      const route = this.currentSlideContentElement(content);
      const target = this.buttonTarget();

      return target ? route : this.route(route);
    },
    currentSlideContentElement(content) {
      return get(this.sectionServicesSlides, [this.currentCategorySlug, this.currentProductSlug, content]);
    },
  },
};
</script>

<style lang="scss" scoped>
section.section-services {
    @screen mobile {
        min-height: 550px;
    }

    @screen tabletLandscape {
        min-height: 1000px;
    }

    @screen desktop {
        min-height: 1000px;
    }

    @screen hd {
        min-height: 1080px;
    }
}
</style>
